// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"ApIcon-module--iconWrapper--18XtP","tooltip":"ApIcon-module--tooltip--3LrRh"};